import React from 'react';

const PageTitleNews = ( { pageTitle, pageDescription }) => {
    return (
        <div id="page-title">
            <div className="wrapper">
                <div className="title" id="title">
                    <h1 className="large"> { pageTitle } </h1>
                </div>

                <div className="description spacer p-top-lg text-max-width-2">
                    <p>{ pageDescription }</p>
                </div>
            </div>
        </div>
    );
};

export default PageTitleNews;
